// src/components/VisionMission.js
import React from 'react';
import { FaEye, FaBullseye } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from '../pages/styles.module.css';

const VisionMission = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.visionMissionContainer}>
      <div className={styles.visionMissionCard}>
        <div className={styles.vmIcon}>
          <FaEye />
        </div>
        <h3 className={styles.vmTitle}>{t('Our Vision')}</h3>
        <p className={styles.vmText}>
          {t('To be a leading provider of premium dairy products that enhance the daily lives of our customers with purity, quality, and authentic taste.')}
        </p>
      </div>
      <div className={styles.visionMissionCard}>
        <div className={styles.vmIcon}>
          <FaBullseye />
        </div>
        <h3 className={styles.vmTitle}>{t('Our Mission')}</h3>
        <p className={styles.vmText}>
          {t('Our journey began in 2018 with a firm belief in the significance of milk in every individual\'s life. We take great pride in offering a wide range of dairy products, including dahi, taak, cow\'s milk, buffalo milk, and ghee. Our commitment is to enrich your daily life with the best dairy products, ensuring each product is safe, nutritious, and delicious.')}
        </p>
      </div>
    </div>
  );
};

export default VisionMission;
